// src/config/config.ts
type AppEnvironment = "dev" | "capacitation" | "test" | "prod";

const API_URL_BY_ENV: Record<AppEnvironment, string> = {
	dev: "https://localhost:7121/api",
	capacitation: "https://api-contassist-awdzataxduh5c5ew.canadacentral-01.azurewebsites.net/api",
	test: "https://sinergiaterritorialapi.dnp.gov.co/api",
	prod: "https://sinergiaterritorialapi.dnp.gov.co/api",
};

const DEFAULT_ENV: AppEnvironment = "prod";
const appEnv = (process.env.REACT_APP_ENV as AppEnvironment | undefined) ?? DEFAULT_ENV;

export const API_URL = API_URL_BY_ENV[appEnv] ?? API_URL_BY_ENV[DEFAULT_ENV];
export const WIDTH_RIGHT_PANEL = "350px";
export const HEIGHT_FOOT = "420px";
export const COLOR_FONT_TITLE = "#36c";
export const esCelular = window.innerWidth < 768 || window.innerHeight < 600;
export const widthCelular = esCelular ? window.innerWidth : "100%";
export const HEIGHT_BODY = esCelular ? `${window.innerHeight - 100}px` : "800px";
export const topFooterOnExpanded = esCelular ? window.innerHeight - 450 : window.innerHeight-50;


//cambios en App.tsx y Detalles.tsx para que el año por defecto sea 2026 en vez de 2025